<template>
  <!-- 出库管理 -->
  <div>
    <!-- 查询 -->
    <Form :model="searchItem" class='header_form' inline style="width:100%">
      <!-- 单位名称 -->
      <FormItem :label="$t('module.text55')+':'">
        <Select v-model="searchItem.deviceModelId" clearable>
          <Option v-for="item in searchDeviceTypes" :value="item.id" :key="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <!-- 仓库 -->
      <FormItem :label="$t('module.text56')+':'">
        <Select v-model="searchItem.warehouseId" clearable filterable>
          <Option v-for="item in warehouse" :value="item.id" :key="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem :label="$t('golbal.text30')+':'">
        <Select v-model="searchItem.state" filterable clearable style="width:200px">
          <Option v-for="item in states" :value="item.id" :key="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem :label="$t('golbal.text76')+':'">
        <Input v-model="searchItem.sn" clearable @on-enter='searchDep'></Input>
      </FormItem>
      <!-- 查询 -->
      <FormItem>
        <Button type="primary" @click="searchDep">{{$t('golbal.text25')}}</Button>
      </FormItem>
    </Form>

    <!-- table -->
    <Table border :height="tableHeight" :columns="columns12" :data="data6" :loading="loading" ref="selection" :no-data-text="$t('golbal.text21')">
      <template slot-scope="{ row }" slot="name">
        <strong>{{ row.name }}</strong>
      </template>
    </Table>
    <!-- 尾部 -->
    <Footer id="footer" style="position: absolute;bottom: 0;width: 100%;padding:0px;z-index:100">
      <!-- 分页 -->
      <Page class="page" :current="searchItem.page" :page-size-opts="Psize" :total="total" :page-size="searchItem.limit" @on-change="ChangePage" @on-page-size-change="ChangePageSize" show-sizer />

    </Footer>
  </div>
  <!-- 单位查询 -->
</template>
<script>
import { selectOutstock, SubWarehouse } from '../../../service/getData'
export default {
  data() {
    return {
      // 查询条件
      searchItem: {
        page: 1, //页码
        limit: 15, //条数
        deviceModelId: '', //设备类型
        warehouseId: '', //仓库
        state: '', //状态
        sn: '' //序列号
      },

      warehouse: [], // 所有仓库

      Psize: [15, 20, 25, 100], // 条数选择
      tableHeight: 700, //table表格高度
      total: 100, // 总条数
      loading: true, //加载状态
      data6: [], // tab数据
      states: [
        {
          id: '1',
          name: this.$t('module.text179')
        },
        {
          id: '2',
          name: this.$t('module.text297')
        },
        {
          id: '3',
          name: this.$t('module.text298')
        }
      ],

      columns12: [
        {
          title: this.$t('module.text58'),
          key: 'brandName',
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('module.text68'),
          key: 'deviceSn',
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('golbal.text77'),
          key: 'deviceModeName',
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('module.text55'),
          key: 'deviceTypeName',
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('module.text296'),
          key: 'whereabouts',
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('module.text300'),
          key: 'warehouseName',
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('module.text184'),
          key: 'deviceCount',
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('golbal.text30'),
          key: 'state',
          align: 'center',
          sortable: true,
          render: (h, params) => {
            if (params.row.state == 1) {
              return h(
                'span',
                {
                  style: {
                    color: '#19be6b'
                  },
                  on: {}
                },
                this.$t('module.text179')
              )
            } else if (params.row.state == 2) {
              return h(
                'span',
                {
                  style: {
                    color: '#ff9900'
                  },
                  on: {}
                },
                this.$t('module.text297')
              )
            } else if (params.row.state == 3) {
              return h(
                'span',
                {
                  style: {
                    color: '#ed4014'
                  },
                  on: {}
                },
                this.$t('module.text298')
              )
            }
          }
        },
        {
          title: this.$t('module.text305'),
          key: 'outStockDate',
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('golbal.text38'),
          key: 'outStockInfo',
          align: 'center'
          // sortable: true
        },
        {
          title: this.$t('module.text306'),
          key: 'operatorName',
          align: 'center',
          sortable: true
        }
      ]
    }
  },
  computed: {
    // 设备型号
    searchModels() {
      return this.$store.state.searchModels
    },
    // 所有设备类型
    searchDeviceTypes() {
      return this.$store.state.searchDeviceTypes
    },
    // 品牌
    searchBrand() {
      return this.$store.state.searchBrand
    }
  },
  created() {
    // 调用封装分页查询
    this.getUnitpaging(this.searchItem)
    // 所有仓库
    SubWarehouse().then((res) => {
      if (res.data.code == 200) {
        this.warehouse = res.data.data
      } else {
        this.$Message.destroy()
        this.$Message.error(res.data.msg)
      }
    })
  },
  methods: {
    // 查询
    searchDep() {
      this.loading = true
      this.searchItem.page = 1
      this.getUnitpaging(this.searchItem)
    },

    // 页面刷新
    Refresh() {
      this.loading = true
      this.searchItem.page = 1
      this.getUnitpaging(this.searchItem)
    },

    // 封装分页查询
    getUnitpaging(data) {
      selectOutstock(data).then((res) => {
        if (res.data.code == 200) {
          this.$Message.destroy()
          this.$Message.success(this.$t('golbal.text14'))
          this.loading = false
          this.data6 = res.data.data.list
          this.total = res.data.data.total
        } else {
          this.$Message.destroy()
          this.$Message.error(res.data.msg)
          this.loading = false
        }
      })
    },

    // 改变页码
    ChangePage(page) {
      this.searchItem.page = page
      this.loading = true
      this.getUnitpaging(this.searchItem)
    },

    // 改变每页数量
    ChangePageSize(size) {
      const Size = size
      this.searchItem.limit = Size
      this.loading = true
      this.getUnitpaging(this.searchItem)
    }
  },
  mounted() {
    // 设置表格高度
    this.tableHeight =
      document.body.clientHeight -
      document.getElementById('footer').offsetHeight -
      165

    window.onresize = () => {
      return (() => {
        this.tableHeight =
          document.body.clientHeight -
          document.getElementById('footer').offsetHeight -
          165
      })()
    }
  }
}
</script>
<style  scoped>
.header_form {
  display: flex;
  flex-wrap: wrap;
}
.header_form .ivu-form-item {
  display: flex;
}
.header_form .ivu-form-item .ivu-form-item-label {
  padding: 0px 5px;
}
.header_form .ivu-form-item .ivu-form-item-content {
  margin: 0px 5px;
}
</style>
